<app-sidenav [toggleEventEmitter]="sidenavToggleEventEmitter">
  <app-navigation-bar [sidenavToggleEventEmitter]="sidenavToggleEventEmitter"></app-navigation-bar>
  <router-outlet></router-outlet>
</app-sidenav>
